import { fetchApi, ApiError } from './client'
import type { AuthStatus } from './types'

/**
 * Check current authentication status.
 * Called on app load to determine if user is logged in.
 */
export async function getAuthStatus(): Promise<AuthStatus> {
  return fetchApi<AuthStatus>('/api/v1/auth/me')
}

/**
 * Login with password.
 * Backend sets session cookie on success.
 */
export async function login(password: string): Promise<{ message: string }> {
  return fetchApi<{ message: string }>('/api/v1/auth/login', {
    method: 'POST',
    body: { password },
  })
}

/**
 * Logout - destroys session.
 */
export async function logout(): Promise<void> {
  return fetchApi<void>('/api/v1/auth/logout')
}
